export enum SitePage {
  Home = "Home",
  Trackers = "Trackers",
  History = "History",
  Alerts = "Alerts",
  Agriculture = "Agriculture",
  Configuration = "Configuration",
  Faucets = "Faucets",
  ActivityLog = "ActivityLog",
  Cameras = "Cameras",
  Deployments = "Deployments",
  LossAnalysis = "LossAnalysis",
  Trends = "Trends",
  Settings = "Settings",
  Inverters = "Inverters",
  Reports = "Reports",
}

export enum MultiSitePage {
  AlertNotifications = "AlertNotifications",
  Permissions = "Permissions",
  CloudConfiguration = "CloudConfiguration",
  Trends = "Trends",
  Multisite = "Multisite",
}
